/**
 * Single search hit — Deakin Life uses one card type for all results.
 */
import DeakinSearchResultCard from './deakin';
import type { SearchResultItem } from '../../types';

type Props = {
  result: SearchResultItem;
};

const SearchResult = (props: Props) => {
  return <DeakinSearchResultCard {...props} />;
};

export default SearchResult;
